import GlobalStyles from './styles/GlobalStyles';
import createTheme from './styles/theme';
import { CURRENCIES } from 'common-ui/src/utils/constants';
import { commonInitApp } from 'common-embedded';

const brandObject = {
  country: 'uk',
  brandId: 'amx',
  currencyCode: CURRENCIES.GBP
};

const initApp = commonInitApp({ brandObject, createTheme, GlobalStyles });

export default initApp;